import { makeObservable, observable } from 'mobx';

import { IEdit } from 'shared/entities/edit';
import {
  IScenarioEdit,
  ScenarioCommonServer,
  ScenarioKind
} from 'shared/entities/scenario';

export default class ScenarioEditModel implements IEdit, IScenarioEdit {
  name: string;

  channelIds: Array<string> | null;

  folderId: string | null;

  id: string | null;

  kind: ScenarioKind.common;

  constructor(
    {
      name,
      channelIds,
      id,
      kind,
      folderId = null
    }: {
      id: string | null;
      name: string;
      kind: ScenarioKind.common;
      channelIds: string[] | null;
      folderId?: string | null;
    } = {
      name: '',
      channelIds: [],
      id: null,
      kind: ScenarioKind.common,
      folderId: null
    }
  ) {
    this.name = name;
    this.channelIds = channelIds;
    this.folderId = folderId;
    this.id = id;
    this.kind = kind;

    makeObservable(this, {
      name: observable,
      channelIds: observable,
      id: observable,
      folderId: observable
    });
  }

  toJson(): Partial<ScenarioCommonServer> {
    return {
      name: this.name,
      channel_ids: this.channelIds,
      kind: this.kind,
      folder_id: this.folderId
    };
  }

  getCopy(): ScenarioEditModel {
    return new ScenarioEditModel({
      name: this.name,
      channelIds: this.channelIds ? [...this.channelIds] : null,
      id: this.id,
      kind: this.kind,
      folderId: this.folderId
    });
  }
}
